export default __webpack_public_path__ + "static/media/138.82b87e9a.gif";